import { FunctionComponent, JSX } from "react";
import { Caption } from "@ppb/the-wall-web";
import { withExchangeJurisdiction, withSportsbookJurisdiction } from "../withJurisdiction/withJurisdiction";
import { OPERATOR_INFO_JURISDICTIONS, operatorInfoTranslation } from "./JurisdictionalOperatorInfo.helper";

const OperatorInfo: FunctionComponent = (): JSX.Element | null =>
  operatorInfoTranslation ? <Caption>{operatorInfoTranslation}</Caption> : null;

export const SportsbookJurisdictionalOperatorInfo = withSportsbookJurisdiction(OperatorInfo, {
  jurisdictions: OPERATOR_INFO_JURISDICTIONS,
});

export const ExchangeJurisdictionalOperatorInfo = withExchangeJurisdiction(OperatorInfo, {
  jurisdictions: OPERATOR_INFO_JURISDICTIONS,
});
